import {flare} from "@flareapp/flare-client";

// bootstrap - You can specify which plugins you need
import { Offcanvas, Tab, Modal, Collapse } from 'bootstrap';

// Only enable Flare in production, we don't want to waste your quota while you're developing:
if (process.env.NODE_ENV === 'production') {
    flare.light('RRmXISHWdqUMXQq3k6SUnV13DvBJnLl9');
}

// init Swiper
// import Swiper from 'swiper';
// import 'swiper/css/bundle';

import currencyAPI from "./modules/currency.js";
import accordion from "./modules/accordion.js";
import slidermanager from "./modules/slider.js";
import heroCarousel from "./modules/hero-carousel.js";
import navmanager from "./modules/nav.js";
import mobilemenu from "./modules/mobilemenu";
import savebasket from "./modules/savebasket";
import studcalculator from "./modules/studcalculator";
import knowledgebase from "./modules/knowledge-base";
import prodFilters from "./modules/prod-filters";
import minibasket from "./modules/mini-basket";
import filterSelect from "./modules/filter-select";
import exitIntent from "./modules/exit-intent";

//import model from "./modules/models.js";
//import plusminus from "./modules/plus-minus-qunatity.js";

document.addEventListener("DOMContentLoaded", function () {
    var studslider = document.getElementById("stud-slider");
    if (studslider) {
        slidermanager.slider();
    }
    heroCarousel.init();
    prodFilters.hideEmptyFilters();
});


const init = function () {
    accordion.accordionToggle();
    navmanager.stickyNavScroll();
    navmanager.observers();
    navmanager.searchtoggle();
    navmanager.megaMenuAccessibility();
    navmanager.subMenuAccessibility();
    mobilemenu.addEvents();
    savebasket.init();
    studcalculator.init();
    minibasket.init();
    //filterProducts.categoryFilter();
    // model.modelToggle();
    currencyAPI.fetchAPI();
    knowledgebase.init();
    filterSelect.init();
    exitIntent.init();
}

jQuery(function ($) {
    $('button[name="update_cart"]', 'form.woocommerce-cart-form').removeAttr('disabled');
    $(document.body).on('updated_cart_totals', function () {
        $("form.woocommerce-cart-form:not(:first)", "section.cart-desktop").remove();
        $("form.woocommerce-cart-form:not(:first)", "section.cart-mobile").remove();
        $("div.cart_totals:not(:first)", "div.cart-collaterals").remove();
        $('button[name="update_cart"]', 'form.woocommerce-cart-form').removeAttr('disabled');
        //location.reload();
    });

    let lastUpdate = 0;
    // Function to handle mutations
    function handleMutations(mutationsList) {
        const now = Date.now();
        if (now - lastUpdate < 50) return;
        lastUpdate = now;
        
        $('.purchase-options .price').html($('.woocommerce-variation-price span.price').html());

        // Check if del element in price
        if ($('.purchase-options .price del').length == 0 && $('.purchase-options .price span.vat').length == 0) {
            $('.purchase-options .price').append('<span class="vat">ex. VAT</span>');
        } else if ($('.purchase-options .price span.price del').length > 0) {
            $('.purchase-options .price span.vat').remove();
        }
    }

    var targetNode = document.querySelector(".single_variation_wrap");
    if (targetNode) {
        var observer = new MutationObserver(handleMutations);
        var config = {subtree: true, childList: true};
        observer.observe(targetNode, config);
    }

    // Product gallery thumbnail accessibility
    $(document).on('keydown', '.flex-control-thumbs img', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).trigger('click');
        }
    });

    function fixGalleryThumbnailA11y() {
        $('.flex-control-thumbs img').each(function(i) {
            $(this).attr({
                'tabindex': '0',
                'role': 'button',
                'aria-label': 'Product thumbnail ' + (i + 1)
            });
        });
    }

    $(window).on('load', fixGalleryThumbnailA11y);
});

var loading = true;
window.onload = function () {
    if (loading) {
        init();
        loading = false;
    }
};

// fix for quantity discounts with currency switcher
jQuery(document).ready(function($) {
    // Store original ajaxComplete behavior
    $(document).ajaxComplete(function(event, xhr, settings) {
        // Check if this is the discount plugin AJAX call
        if (settings.data && settings.data.includes('action=wdr_ajax') && settings.data.includes('method=get_price_html')) {
            try {
                var response = JSON.parse(xhr.responseText);
                console.log('testing response: ', response);

                if (response.price_html) {
                    var priceHtml = response.price_html;
                    console.log('price html: ', priceHtml);
                    var price;

                    // Better regex to find the discounted price in the <ins> tag with nested HTML
                    var insMatch = priceHtml.match(/<ins>.*?(\d+\.\d+).*?<\/ins>/);
                    console.log('ins match: ', insMatch);

                    if (insMatch) {
                        // Found discounted price
                        price = insMatch[1];
                        console.log('discounted price found: ', price);
                    } else {
                        // No discount, get all prices and take the last one (should be the active price)
                        console.log('no ins tag found, looking for regular price');

                        var allPrices = priceHtml.match(/\d+\.\d+/g);
                        console.log('all prices found: ', allPrices);

                        if (allPrices && allPrices.length > 0) {
                            // If there are multiple prices, the last one is usually the current price
                            price = allPrices[allPrices.length - 1];
                            console.log('taking last price: ', price);
                        }
                    }

                    if (price) {
                        $('.price').attr('data-gbp-price', price);
                        console.log('Final: Set data-gbp-price to:', price);
                    } else {
                        console.log('No price found!');
                    }
                }
            } catch (e) {
                console.log('Error parsing discount response:', e);
            }
        }
    });
});